export default "__VITE_ASSET__xAMF6m0H__"